'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIAbstractDateInput = require('./abstract/UIAbstractDateInput');

var _UIAbstractDateInput2 = _interopRequireDefault(_UIAbstractDateInput);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITextInput = require('./UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 10;

var USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};

var UIDateInput = _react2.default.createClass({
  displayName: 'UIDateInput',

  propTypes: _extends({}, (0, _underscore.omit)(_UIAbstractDateInput2.default.propTypes, ['children']), {
    className: _react.PropTypes.string,
    containerClassName: _react.PropTypes.string,
    icon: _react.PropTypes.bool,
    inputRef: _refObject2.default,
    size: _react.PropTypes.oneOf(['small', 'default']),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired,
    styled: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIAbstractDateInput2.default.defaultProps, {
      icon: false,
      placeholder: '',
      size: 'default',
      styled: true,
      use: 'default'
    });
  },
  renderIcon: function renderIcon(_ref) {
    var size = _ref.size,
        styled = _ref.styled;

    return _react2.default.createElement(_UIIcon2.default, {
      name: _icons2.default.DATE,
      className: (0, _reactUtils.classNames)('private-form__control__icon--leading', {
        'private-form__control__icon--leading-small': size === 'small',
        'private-form__control__icon--unstyled': !styled
      }),
      size: size === 'small' ? 'small' : 24
    });
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        className = _props.className,
        containerClassName = _props.containerClassName,
        icon = _props.icon,
        inputRef = _props.inputRef,
        size = _props.size,
        styled = _props.styled,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['className', 'containerClassName', 'icon', 'inputRef', 'size', 'styled', 'use']);

    return _react2.default.createElement(
      _UIAbstractDateInput2.default,
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-date-input', containerClassName),
        ref: this.dateInputRefCallback
      }),
      function (dateProps) {
        return _react2.default.createElement(
          'div',
          null,
          icon ? _this.renderIcon({ size: size, styled: styled }) : null,
          _react2.default.createElement(_UITextInput2.default, _extends({}, (0, _underscore.omit)(dateProps, ['hideFocusOutline', 'isPickerOpen']), {
            className: (0, _reactUtils.classNames)('private-form__control', 'uiDateInputInput', 'private-date-input__input', {
              'private-form__control--small': size === 'small',
              'private-form__control--with-leading-icon': icon
            }, USE_CLASSES[use], className),
            inputRef: inputRef,
            size: size === 'small' ? DEFAULT_SIZE + 1 : DEFAULT_SIZE,
            styled: styled
          }))
        );
      }
    );
  }
});

exports.default = (0, _ShareInput2.default)((0, _Controllable2.default)(UIDateInput));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UIDateInput.js
// module id = 371
// module chunks = 0